export const navigation = [
  { label: 'Home', path: '/' },
  { label: 'Certificaciones', path: '/certificaciones' },
  {
    label: 'Servicios',
    path: '/servicios',
    children: [
      { label: 'Nuestro servicio', path: '/servicios#nuestro-servicio' },
      { label: 'Otras acciones', path: '/servicios#otras-acciones' },
    ],
  },
  { label: 'Economía Circular', path: '/economia-circular' },
  { label: 'Ley REP', path: '/ley-rep' },
  {
    label: 'Nosotros',
    path: '/nosotros',
    children: [
      { label: 'Política Ambiental', path: '/nosotros#politica-ambiental' },
      { label: 'Espíritu', path: '/nosotros#espiritu' },
      { label: 'Historia', path: '/nosotros#historia' },
      { label: 'Resoluciones', path: '/nosotros#resoluciones' },
      { label: 'Premios', path: '/nosotros#premios' },
      { label: 'Aliados', path: '/nosotros#aliados' },
    ],
  },
  { label: 'Medios', path: '/medios' },
  { label: 'Contacto', path: '/contacto' },
];
